// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "@firebase/firestore"


const firebaseConfig = {
  apiKey: "AIzaSyCxtJvd8mBevmiaKvdSnbUvizX4gEeqqGk",
  authDomain: "support305-b4d55.firebaseapp.com",
  projectId: "support305-b4d55",
  storageBucket: "support305-b4d55.appspot.com",
  messagingSenderId: "49563518241",
  appId: "1:49563518241:web:416d5db14aed286c6c2a60",
  measurementId: "G-8SS62QDQZN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);


// Fconst analytics = getAnalytics(app);

export const firestore = getFirestore(app)